const executeIfFunction = f => (f instanceof Function ? f() : f);

const switchCase = cases => defaultCase => key => cases.hasOwnProperty(key) ? cases[key] : defaultCase;

export const customSwitch =
  cases =>
  defaultCase =>
  <T>(key: T) =>
    executeIfFunction(switchCase(cases)(defaultCase)(key));
